import NiceModal from '@ebay/nice-modal-react';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const AuthLayout = (props: React.PropsWithChildren) => {
  return (
    <ChakraV3.Center bg='extraDarkPurple' h='100vh' userSelect='none'>
      {/* We add a Modal provider here because we don't have one
      available for auth. Auth lives outside the main context hierarchy */}
      <NiceModal.Provider>
        <div id='recaptcha-container'>
          <div id='recaptcha' />
        </div>
        {props.children}
      </NiceModal.Provider>
    </ChakraV3.Center>
  );
};
